import { Component, ReactNode } from 'react';

import { MapType, MapUnavailable } from '@/components/map/MapUnavailable';

type Props = { mapType: MapType; children: ReactNode };
type State = { error?: Error };

export class MapErrorBoundary extends Component<Props, State> {
    state: State = {};

    static getDerivedStateFromError(error: Error): State {
        return { error };
    }

    componentDidCatch(error: Error) {
        console.error('Map render failed', error);
    }

    render() {
        if (this.state.error) {
            return (
                <MapUnavailable
                    mapType={this.props.mapType}
                    source="errorBoundary"
                    errorMessage={this.state.error.message}
                />
            );
        }
        return this.props.children;
    }
}
